export default __webpack_public_path__ + "static/media/tos.76fb082f.htm";